import { Grid } from "@material-ui/core";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import MainContainer from "../components/containers/MainContainer";
import TopBar from "../components/containers/TopBar";
import FetchLogin from "../components/Fetch/FetchLogin";

export default function AgentHistory() {
  const user = useSelector((state) => state.login.user);
  const token = useSelector((state) => state.login.token);
  const [v, setV] = React.useState({
    history: [],
  });

  const reqHistory = FetchLogin("agent-history", {
    data: { token: token },
    callback: (cb) => {
      if (cb.response.success) {
        setV2({
          history: cb.response.data.history,
        });
      }
    },
  });

  const setV2 = (v2) => {
    setV((prev) => ({ ...prev, ...v2 }));
  };

  useEffect(() => {
    reqHistory.handleTrigger();
    // eslint-disable-next-line
  }, []);
  return (
    <MainContainer
      render={
        <Grid container>
          <Grid
            item
            xs={12}
            style={{
              height: 100,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              //   paddingBottom: 32,
              borderBottom: "1px solid #ddd",
            }}
          >
            <TopBar
              leftSide="-1"
              title={
                <>
                  {user.name}
                  <br />
                  Agent ID: {user.agent_id}
                  <br />
                </>
              }
            />
          </Grid>
        </Grid>
      }
    >
      <h1 style={{ textAlign: "center" }}>Agent History Per Day</h1>
      <div className="agent-history">
        {/* {pre(v.history)} */}
        <div>
          <div>Date</div>
          <div>Sum of Bets</div>
          <div>Status</div>
        </div>
        {/* <div className="expired">
          <div>19 Feb Sun</div>
          <div>S$ 102</div>
          <div>Expired</div>
        </div>
        <div className="expired">
          <div>20 Feb Mon</div>
          <div>S$ 101</div>
          <div>Expired</div>
        </div>
        <div>
          <div>21 Feb Tue</div>
          <div>S$ 110</div>
          <div>Active</div>
        </div>
        <div>
          <div>22 Feb Wed</div>
          <div>S$ 99</div>
          <div>Active</div>
        </div>
        <div>
          <div>23 Feb Thu</div>
          <div>S$ 73</div>
          <div>Active</div>
        </div>
        <div>
          <div>24 Feb Fri</div>
          <div>S$ 12</div>
          <div>Active</div>
        </div>
        <div>
          <div>25 Feb Sat</div>
          <div>S$ 42</div>
          <div>Active</div>
        </div>
        <div>
          <div>26 Feb Sun</div>
          <div>S$ 45</div>
          <div>Active</div>
        </div>
        <div>
          <div>27 Feb Mon</div>
          <div>S$ 32</div>
          <div>Active</div>
        </div>
        <div>
          <div>
            <b>Total</b>
          </div>
          <div>
            <b>S$ 413</b>
          </div>
          <div></div>
        </div> */}
        {v.history.map((item, index) => (
          <div key={index}>
            <div>{item.date}</div>
            <div>S${item.sum_of_bet}</div>
            <div>{item.status}</div>
          </div>
        ))}
      </div>
    </MainContainer>
  );
}
